<template>
  <section class="bg-white">
    <div class="container">
      <div class="fx">
      <h6 class="section-heading">Personality</h6>
      <h3 class="section-title">Search with personality type</h3>
      <p class="section-desc">
        Start-up enthusiast or a hard core techie? Humanitarian Volunteer or a
        studious scholar? Get hooked on to opportunities and workplaces that
        matches your personality.
      </p>
  </div>
<div class="process-wrap show-on-lg">
  <div class="process">
    <div class="process__item" v-for="(p, index) in personality_data" :key="index">
      <div class="testing">
            <vs-card class="personality-card no-shadow px-6">
              <div class="mt-3 mb-1" slot="media">
                <span
                  class="
                    p-3
                    inline-flex
                    rounded-full
                    feather-icon
                    select-none
                    relative
                    text-primary
                    mc-icon
                  "
                >
                  <img
                    :src="p.icon"
                    :alt="p.title"
                    width="64px"
                    height="64px"
                  />
                </span>
              </div>
              <div class="text-left">
                <h6 class="personality-title mb-3">{{ p.title }}</h6>
                <p class="personality-description">{{ p.description }}</p>
              </div>
            </vs-card>
          </div>
    </div>
    <!-- <div class="process__item">
      <p>
        <span>2</span>
        Whatever the solution, it is only a first step of a great journey. We’ll be by your side when the need for further improvements, optimization or additional functionality arises. Feel free to contact when it is time to level up – we’ll accompany you in exploring new paths.
      </p>
    </div>
    <div class="process__item">
      <p>
        <span>3</span>
        Whatever the solution, it is only a first step of a great journey. We’ll be by your side when the need for further improvements, optimization or additional functionality arises. Feel free to contact when it is time to level up – we’ll accompany you in exploring new paths.
      </p>
    </div> -->
  </div>
</div>

<vs-row class="container personality-row hidden-on-lg" vs-type="flex">
        <vs-col
          v-for="(p, index) in personality_data"
          :key="index"
          class="sm:w-full lg:w-1/3 p-0 mb-4"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
        >
          <vs-card class="personality-card p-4 mr-4">
            <div class="mt-3 mb-1" slot="media">
              <span
                class="
                  p-3
                  inline-flex
                  rounded-full
                  feather-icon
                  select-none
                  relative
                  text-primary
                  mc-icon
                "
              >
                <img :src="p.icon" :alt="p.title" width="64px" height="64px" />
              </span>
            </div>
            <div class="text-left">
              <h6 class="personality-title mb-3">{{ p.title }}</h6>
              <p class="personality-description small-width">{{ p.description }}</p>
            </div>
          </vs-card>
        </vs-col>
      </vs-row>
          
    </div>
    <div class="end"></div>
  </section>
</template>

<script>
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { defaultPersonalityTraits_en } from "@/assets/data/personality.js";
import { Carousel, Slide } from "vue-carousel";
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);
export default {
  name: "PersonalityNew",
  components: { Carousel, Slide },
  data() {
    return {
      personality_data: defaultPersonalityTraits_en,
    };
  },
  methods: {
    personalityAnimation(){
      
        ScrollTrigger.matchMedia({
      "(min-width: 1250px)": function () {
  const process = document.querySelector('.process');
  if ((typeof(process) != 'undefined' && process != null)) {
    let sections = gsap.utils.toArray('.process__item');
    let t3 = gsap.to(sections, {
      xPercent: -100 * (sections.length - 1),
      ease: "none",
      scrollTrigger: {
        trigger: process,
        markers: false,
        scrub: 1,
        pin: true,
        snap: 1 / (sections.length - 1),
        end: () => "+=" + document.querySelector(".process").offsetWidth
      },
    });
  }
      


let t5 = gsap.to(".fx", {
      scrollTrigger: {
        trigger: ".fx",
        start: 'top top',
        toggleClass: 'fixed',
        end: 4500
      },
    });
    }
        });
    }

  },
  mounted(){
    this.personalityAnimation();
  }
};
</script>

<style scoped>
.hidden-on-lg {
  display: none !important;
}
.fixed {
  position: fixed;
    z-index: 1000;
    top: 0;
}
/* .fx{
  position:absolute;
} */
.testing {
 width: 275px;
    height: 300px;
}
.small-width {
  width: 50%!important;
}
.personality-description {
  width: 90%;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 180%;
  color: #5d6473;
}
.personality-title {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 140%;
  /* or 22px */

  color: #5585ff;
}
section {
  padding: 7rem;
}
.section-desc {
  width: 60%;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 180%;
  /* or 29px */

  color: #5d6473;
}
.section-heading {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 170%;
  /* identical to box height, or 24px */

  letter-spacing: 0.8px;
  text-transform: uppercase;

  color: #44cc88;
}
.section-title {
  font-style: normal;
  font-weight: bold;
  font-size: 40px;
  line-height: 140%;
  color: #121127;
}




.process-wrap {
  overflow: hidden;
}
.process {
  margin-top:15%;
  width: 300%;
  display: flex;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -ms-flex-item-align: center;
  align-self: center;
  height: 100vh!important;
}
  .process__item {
    display: flex;
    align-items: center;
    padding: 0 20px;
  }

   @media (max-width: 992px) {
   section {
     padding: 0;
   }
   .hidden-on-lg {
  display: flex!important;
}
.show-on-lg {
  display: none;
}
.personality-row {
    margin-top: 5rem;
  }
   }

</style>